<!--
  --
  --
  --
  -->
<template>
  <v-sheet>
    <c-book-subheader>連絡事項</c-book-subheader>

    <v-sheet class="pa-2 mb-4" color="secondary" rounded>
      <c-description class="text-caption">
        <p>
          店舗への連絡事項などございましたらご入力下さい。
        </p>
      </c-description>
    </v-sheet>

    <v-textarea
      label="連絡事項"
      :value="value"
      @change="$emit('change', $event)"
      rows="6" no-resize outlined
    />
  </v-sheet>
</template>

<script>
import CBookSubheader from '@/pages/book/components/CBookSubheader'
import CDescription from '@/components/CDescription'

export default {
  name: 'CNoteSheet',
  components: {
    CBookSubheader,
    CDescription
  },

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String
    }
  }
}
</script>
